<template>
<div>
    <span class="label" :class="{
            'label-primary' : minutos <= valor_1,
            'label-warning': minutos > valor_1 && minutos <= valor_2,
            'label-danger' : minutos > valor_2
       }"><i class="fas " :class="{
           'fa-check-circle' :  minutos <= valor_1,
           'fa-exclamation-triangle': minutos > valor_1 && minutos <= valor_2,
           'fa-radiation-alt' : minutos > valor_2
       }"> {{time}} </i></span>

         <!-- <span class="label" :class="{
            'label-primary' : minutos <= umbrales(['inter_pend']).valor_1,
            'label-warning': minutos > umbrales(['inter_pend']).valor_1 && minutos <= umbrales(['inter_pend']).valor_2,
            'label-danger' : minutos > umbrales(['inter_pend']).valor_2
       }"><i class="fas " :class="{
           'fa-check-circle' :  minutos <= umbrales(['inter_pend']).valor_1,
           'fa-exclamation-triangle': minutos > umbrales(['inter_pend']).valor_1 && minutos <= umbrales(['inter_pend']).valor_2,
           'fa-radiation-alt' : minutos > umbrales(['inter_pend']).valor_2
       }"> {{time}} </i></span> -->
</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: "Cronometro",
    props: [
        'delta'
    ],
    data() {
        return {
            isRunning: false,
            time: '00:00:00',
            timeBegan: null,
            stared: null,
            minutos: '00',
        }
    },
    mounted() {
        this.comenzar();
        this.obtenerUmbrales();
    },
    beforeDestroy() {
        clearTimeout(this.stared)
    },
    methods: {
        obtenerUmbrales() {
            this.$store.dispatch('interacciones/obtenerUmbrales')
                .then(response => {
                    //
                }).catch(error => {
                    //
                })
        },
        zeroPrefix(num, digit) {
            let zero = '';
            for (let i = 0; i < digit; i++) {
                zero += '0';
            }
            return (zero + num).slice(-digit);
        },
        comenzar() {
            this.timeBegan = new Date();
            this.timeBegan.setTime(this.timeBegan.getTime() - (this.delta * 1000)); // date.setTime(date.getTime() + (seconds * 1000));
            this.stared = setInterval(this.clockRunning, 1000);
            this.isRunning = true
        },
        clockRunning() {
            let currentTime = new Date(),
                timeElapsed = new Date(currentTime - this.timeBegan),
                hour = timeElapsed.getUTCHours(),
                min = timeElapsed.getUTCMinutes(),
                sec = timeElapsed.getUTCSeconds();
            this.time = this.zeroPrefix(hour, 2) + ":" +
                this.zeroPrefix(min, 2) + ":" +
                this.zeroPrefix(sec, 2);

            this.minutos = (parseInt(this.zeroPrefix(hour, 2)) * 60) + parseInt(this.zeroPrefix(min, 2));
        }
    },
    computed: {
        // ...mapGetters({
        //     umbrales: 'interacciones/getUmbralesSlug',
        // }),
        valor_1:{
            get(){
                let inter_pend = this.$store.getters['interacciones/getUmbralesSlug']('inter_pend')
                // console.log(inter_pend.valor_1);
                if(inter_pend)
                    return inter_pend.valor_1
                else
                    return 30
            }
        },
         valor_2:{
            get(){
                let inter_pend = this.$store.getters['interacciones/getUmbralesSlug']('inter_pend')
                // console.log(inter_pend.valor_1);
                if(inter_pend)
                    return inter_pend.valor_2
                else
                    return 60
            }
        }
    }
}
</script>
